import { Time } from '@components/CarpayOrderCard/CarpayOrderCard.style'
import { DateTime } from 'luxon'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import CarpayPaymentResult from '../CarpayPaymentFinished.component'
import Button from 'parkdepot-shared/components/Buttons/Button'
import carpayOrderListRoute from '@views/Carpay/OrderList/route.const'

interface PaymentSuccessProps {
    price: number
    plate: string
    now: DateTime
    priceValidUntil: string
    nextOrderId: string | null
    isTollroad: boolean
    redirectUrl: string | null
}

const PaymentSuccess = ({
    price,
    plate,
    now,
    priceValidUntil,
    nextOrderId,
    isTollroad,
    redirectUrl
}: PaymentSuccessProps) => {
    const history = useHistory()
    const { t } = useTranslation()
    const parsedPriceValidUntil = DateTime.fromISO(priceValidUntil)
    const exitTime = parsedPriceValidUntil.toFormat('HH:mm')
    const relativeTime = parsedPriceValidUntil.toRelativeCalendar({ unit: 'days' })
    let title = t('carpay.paymentFinished.title')
    if (price === 0) title = t('carpay.paymentFinished.free')

    let subtitle: ReactNode = t('carpay.paymentFinished.subtitle', { exitTime, relativeTime })
    if (isTollroad) {
        subtitle = <>{t('carpay.paymentFinished.tollroad')}</>
    }

    return (
        <CarpayPaymentResult>
            <CarpayPaymentResult.Icon variant="Authorised" className="wemolo-check-circle" />
            <CarpayPaymentResult.Title variant="Authorised">
                <span data-testid="payment-success">{title}</span>
            </CarpayPaymentResult.Title>
            <CarpayPaymentResult.Subtitle>{subtitle}</CarpayPaymentResult.Subtitle>
            <div>
                <FormPlateInput disabled readOnly value={plate} />
                <Time>{now.toFormat('dd.MM.yyyy HH:mm')}</Time>
            </div>

            {!!nextOrderId ? (
                <Button
                    id="next-order-button"
                    $kind={BUTTON_KIND.primary}
                    $size={BUTTON_SIZE.medium}
                    onClick={() => history.replace(`${carpayOrderListRoute}?plate=${plate}&order_id=${nextOrderId}`)}
                >
                    {t('carpay.paymentFinished.nextOrder')}
                </Button>
            ) : null}
            {redirectUrl && (
                <Button
                    onClick={() => {
                        history.push(redirectUrl)
                    }}
                    $kind={BUTTON_KIND.primary}
                    $size={BUTTON_SIZE.medium}
                >
                    {t('accountCreationAd.savePlate')}
                </Button>
            )}
        </CarpayPaymentResult>
    )
}

export default PaymentSuccess
